export default __webpack_public_path__ + "static/media/syria.6b49d42f.jpg";